module.exports = __webpack_public_path__ + "img/cart.5521d8db.svg";